import {extendTheme} from 'native-base';

export const customTheme = extendTheme({
  config: {
    useSystemColorMode: true
  },
  colors: {
    primary: {
      '50': '#EAE0FB',
      '100': '#DDCEF8',
      '200': '#C5AAF3',
      '300': '#AC87EE',
      '400': '#9463E9',
      '500': '#7B3FE4',
      '600': '#5D1DCE',
      '700': '#47169D',
      '800': '#310F6C',
      '900': '#1A083A'
    },
    secondary: {
      50: '#f1f1fb',
      100: '#d7d7dd',
      200: '#bdbdc2',
      300: '#a2a2a8',
      400: '#88888f',
      500: '#6e6e75',
      600: '#56565c',
      700: '#3d3d42',
      800: '#25252a',
      900: '#0b0b14'
    }
  },
  components: {
    Text: {
      defaultProps: {
        fontSize: 'md',
        color: 'muted.900'
      }
    },
    Divider: {
      defaultProps: {
        bgColor: 'gray.200'
      }
    },
    Input: {
      baseStyle: {
        px: '3',
        py: '2.5'
      },
      sizes: {
        md: {
          fontSize: 'md'
        }
      }
    },
    Button: {
      baseStyle: {
        _spinner: {
          height: '24px'
        }
      },
      sizes: {
        md: {
          px: '3',
          py: '2.5',
          _text: {
            fontSize: 'md'
          },
          _icon: {
            size: 'md'
          }
        }
      }
    }
  }
});

type CustomThemeType = typeof customTheme;

declare module 'native-base' {
  interface ICustomTheme extends CustomThemeType {}
}
